import DeleteIcon from '@mui/icons-material/Delete';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import actions, { selectors } from '../../modules/apartments';
import { selectors as companySelectors } from '../../modules/company';
import { selectors as siteSelectors } from '../../modules/sites';
import ButtonDanger from '../ButtonDanger';
import Modal from '../Modal';
import messages from './messages';

function ApartmentDeleteConfirmModal() {
  const dispatch = useDispatch();
  const siteId = useSelector(siteSelectors.getSiteId);
  const open = useSelector(selectors.isDeleteModalOpen);
  const companyId = useSelector(companySelectors.getCompanyId);
  const isFetching = useSelector(selectors.isDeleteApartmentFetching);
  const apartmentId = useSelector(selectors.getApartmentIdFromDeleteModal);

  return (
    <Modal
      actions={
        <>
          <Button color="secondary" onClick={() => dispatch(actions.deleteApartmentHideModal())}>
            <FormattedMessage {...messages.apartmentDeleteConfirmModalCancelButton} />
          </Button>
          <ButtonDanger
            isLoading={isFetching}
            onClick={() => dispatch(actions.deleteApartment(companyId, siteId, apartmentId))}
            startIcon={<DeleteIcon />}
          >
            <FormattedMessage {...messages.apartmentDeleteConfirmModalConfirmButton} />
          </ButtonDanger>
        </>
      }
      headerVariant="danger"
      maxWidth="xs"
      name="delete-apartment"
      onClose={() => dispatch(actions.deleteApartmentHideModal())}
      open={open}
      title={<FormattedMessage {...messages.apartmentDeleteConfirmModalTitle} />}
    >
      <Typography paragraph>
        <FormattedMessage {...messages.apartmentDeleteConfirmModalText} />
      </Typography>
    </Modal>
  );
}

export default ApartmentDeleteConfirmModal;
